module.exports = __webpack_public_path__ + "static/steps-screenshot-f23f9d932f7cf3b9f4755bd41d7c94e0.png";